import BaseApiRequest from "./BaseApiRequest";
import { REGISTER_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class RegistrationRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  constructor(userDetail) {
    super();
    this.body = userDetail;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(REGISTER_URL);

  getBody = () => this.body;
}
